import React from 'react';

import Button from '@atlaskit/button';
import EditorSearchIcon from '@atlaskit/icon/glyph/editor/search';
import HipchatChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';
import HipchatChevronUpIcon from '@atlaskit/icon/glyph/hipchat/chevron-up';
import { Popup } from '@atlaskit/popup';

import { TextField } from '@qality/common-components/src/atoms/TextField';

import { SelectContentBodyStyled } from './Select.styled';

type Props = {
  children: React.ReactNode;
  isOpen: boolean;
  handleClose: () => void;
  handleToggle: () => void;
  searchValue: string;
  onChangeText: (value: string) => void;
  triggerDescription: string;
};

export const SelectView = ({
  children,
  isOpen,
  handleClose,
  handleToggle,
  searchValue,
  onChangeText,
  triggerDescription,
}: Props): JSX.Element => {
  const handleChangeSearch = (e) => {
    onChangeText(e.target.value);
  };

  return (
    <Popup
      isOpen={isOpen}
      onClose={handleClose}
      placement='bottom-start'
      content={() => (
        <SelectContentBodyStyled>
          <TextField
            value={searchValue}
            onChange={handleChangeSearch}
            suffixComponent={<EditorSearchIcon label='issue-search' />}
            placeholder='Search issue'
          />
          {children}
        </SelectContentBodyStyled>
      )}
      trigger={(triggerProps) => (
        <Button
          {...triggerProps}
          shouldFitContainer
          onClick={handleToggle}
          isSelected={isOpen}
          style={{ textAlign: 'left' }}
          iconAfter={
            isOpen ? (
              <HipchatChevronUpIcon
                size='small'
                label='issue-select-chevron-up'
              />
            ) : (
              <HipchatChevronDownIcon
                size='small'
                label='issue-select-chevron-down'
              />
            )
          }
        >
          {triggerDescription}
        </Button>
      )}
    />
  );
};
